<template>
<b-tab lazy title-item-class="mr-1" :title-link-class="{'bg-danger': hasErrors, 'bg-warning': isDirty}">
    <template slot="title">
        <i v-if="isDirty || hasErrors" class="fa-solid fa-circle-exclamation" :class="{ 'fa-circle-exclamation text-white': hasErrors, 'fa-cloud-arrow-up text-black': isDirty}"></i> Ontslagbrief
    </template>
    <ontslagbrief-base button-top small fixed :callback="createPatientAdminOntslagbrief" />
</b-tab>
</template>
<script>
import TabExtension from "../TabExtension"
import OntslagbriefBase from "@/core/components/health/ontslagbrief/OntslagbriefBase"
import { mapActions } from "vuex"

export default TabExtension.extend({
    name: "ontslagbrief",
    components: {
        'ontslagbrief-base': OntslagbriefBase
    },
    methods: {
        ...mapActions('health', ['createPatientAdminOntslagbrief']),
    }
})
</script>
